import { RCADashboardContextProvider } from "contexts/RCADashboardContext/RCADashboardContextProvider";
import { useRCAMainStyles } from "../RCA.styles";
import { useStyles } from "./RCADashboard.styles";
import MyActionPlans from "./components/MyActionPlans";
import MyIssues from "./components/MyIssues";
import MyRCAs from "./components/MyRCAs";
import PendingApprovalActionPlan from "./components/PendingApprovalActionPlan";
import { useTranslation } from "react-i18next";

const RCADashboard = () => {
    const { t } = useTranslation();
    const mainClasses = useRCAMainStyles();
    const classes = useStyles();

    return (
        <RCADashboardContextProvider>
            <div className={mainClasses.mainWrapper}>
                <div className={mainClasses.contentTitle}>{t("rca.rca_dashboard.title")}</div>
                <div className={`${mainClasses.contentWrapper} ${classes.rcaDashboardContentWrapper}`}>
                    <PendingApprovalActionPlan />
                    <MyRCAs />
                    <MyActionPlans />
                    <MyIssues />
                </div>
            </div>
        </RCADashboardContextProvider>
    );
};

export default RCADashboard;
